/**
 * Clones the 30-day guarantee badge beneath Appstle's add-to-cart button.
 *
 * The badge itself is server-rendered once inside the cart summary. Appstle's
 * widget renders client-side and re-renders on every change, so the product-page
 * copy has to be inserted by script and re-inserted whenever the widget wipes it.
 *
 * Only ever inserts a sibling AFTER Appstle's button — never modifies the
 * widget's own nodes, which is what breaks when you restyle it directly.
 */
(function () {
  var BUTTON = '.ab-mix-and-match-add-to-cart-button';

  function ensure() {
    var button = document.querySelector(BUTTON);
    if (!button) return;
    if (document.querySelector('[data-mimu-guarantee-pdp]')) return;

    var source = document.querySelector('[data-mimu-guarantee-full]');
    if (!source) return;

    var clone = source.cloneNode(true);
    clone.removeAttribute('data-mimu-guarantee-full');
    clone.removeAttribute('hidden');
    clone.setAttribute('data-mimu-guarantee-pdp', '');
    clone.classList.add('mimu-gt--pdp');

    // Sit below the protection panel if one is already there, otherwise directly
    // under the button.
    var anchor = button.parentElement && button.parentElement.querySelector('[data-mimu-pp]');
    if (anchor && anchor.parentElement === button.parentElement) {
      anchor.insertAdjacentElement('afterend', clone);
    } else {
      button.insertAdjacentElement('afterend', clone);
    }
  }

  new MutationObserver(function () { ensure(); }).observe(document.body, {
    childList: true,
    subtree: true
  });

  setInterval(ensure, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensure);
  } else {
    ensure();
  }
})();
